import { render, staticRenderFns } from "./FileListItemImage.vue?vue&type=template&id=5e4f0544&"
import script from "./FileListItemImage.vue?vue&type=script&lang=js&"
export * from "./FileListItemImage.vue?vue&type=script&lang=js&"
import style0 from "./FileListItemImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports